export const getLoggableProps = (props) => ({
    sectionName: props.sectionName,
    isLoading: props.isLoading,
    isLazy: props.isLazy,
    sliderBaseNum: props.sliderBaseNum,
    sliderBreakpoints: props.sliderBreakpoints,
    personalizedContent: props.personalizedContent,
    className: props.className,
    mixpanelMetadata: props.mixpanelMetadata,
    showTranslatedUGC: props.showTranslatedUGC,
    recentlyViewedChoiceGigs: props.recentlyViewedChoiceGigs,
    choiceAlgos: props.choiceAlgos,
    collectProps: props.collectProps,
    appName: props.appName,
    perseusName: props.perseusName,
    funnelName: props.personalizedContent.funnelName,
    pageName: props.personalizedContent.pageName,
});
